import styled from 'styled-components';

/**
 * The shared surface shell every strip card composes (BounceCard and ConfirmationCard),
 * so they paint identically. It just FILLS its {@link ScrollStrip} Slot — the Slot owns the
 * size + overlap and the choreography writes the transform; the shell owns only the rounded,
 * clipped card surface. It carries NO transform of its own.
 *
 * It deliberately sets NO border and NO background — each card paints its own surface
 * (BounceCard = artwork; ConfirmationCard = frosty black glass). 24px radius + clip per the
 * Figma deploy-step card.
 */
export const CardShell = styled.article`
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  overflow: hidden;
  outline: none;
`;
